import { postLogin } from '@_api/login';
import { sendRegister } from '@_api/user';
import { getUserData, checkIsEuropeCountry } from '@helpers/form-validators';

const signUp = {
  init: function () {
    this.buildCustomListener();
    this.setupSubmit();

    if (window && window.signupData) {
      var showvat = checkIsEuropeCountry();
      let accountTaxForm = document.querySelector('.saig-o-form-accordion[data-name=account-and-tax]');
      if ((showvat || window.signupData.requestPayByAccount == "True") && accountTaxForm) {
        accountTaxForm?.classList.remove("hide");
        accountTaxForm.parentElement && (accountTaxForm.parentElement.style.display = "display");
      }
      else {
        accountTaxForm?.classList.add("hide");
        accountTaxForm?.parentElement && (accountTaxForm.parentElement.style.display = "none");
      }
    }
  },

  buildCustomListener: function () {
    window.addEventListener('verifyRegister', this.verifyRegister);
  },
  showModal: function (show: boolean) {
    if (!show) {
      window.currentModalId = undefined;
    }

    const modalDiv = document?.querySelector<HTMLDivElement>('.saig-o-modal');
    show ? modalDiv?.classList.remove('display-none') : modalDiv?.classList.add('display-none');
  },
  verifyRegister: () => {
    const registerButton = document.querySelector('.saig-o-signup-form__section-register button') as HTMLButtonElement;
    const disableCapcha = registerButton.dataset.disableCapcha;
    var showvat = checkIsEuropeCountry();
    const { billingAndDelivery, personal, preferencesAndMembership, accountAndTax, capchaVerify } = window.signupFormStatus;

    if (billingAndDelivery && personal && (!showvat || accountAndTax) && preferencesAndMembership && (disableCapcha || capchaVerify)) {
      registerButton.disabled = false;
    } else {
      registerButton.disabled = true;
    }
  },

  showMessage: (type: 'success' | 'fail' | 'error') => {
    const message = document.querySelector<HTMLDivElement>('.saig-o-signup-form__message');
    if (message) {
      if (type === 'success') {
        message.classList.add('success');
      } else {
        message.classList.remove('success');
      }

      message.innerText = message.dataset[type] ?? '';
    }
  },

  setupSubmit: function () {
    const registerButton = document.querySelector('.saig-o-signup-form__section-register button') as HTMLButtonElement;
    const dataAttrAPI = document.querySelector<HTMLDivElement>('.saig-o-sign-in__inner');

    registerButton.addEventListener('click', (e) => {
      e.preventDefault();
      registerButton.disabled = true;
      const url = registerButton.dataset.registerUrl;
      const data = getUserData({ isNewUser: true });
      try {
        sendRegister(data, window.signupData.currentCountry ?? '', url)
          .then((data) => {
            if (data === true) {
              this.showMessage('success');

              const { email, password } = window.signupData.personal || {};

              postLogin(email, password, dataAttrAPI?.dataset.apiUrl ?? '')
                .then((response) => {
                  if (response == 'Success') {
                    const redirecturl = window.localStorage.getItem("redirectAfterRegister");

                    if (redirecturl) {
                      window.localStorage.removeItem("redirectAfterRegister");
                      setTimeout(() => {
                        window.location.href = redirecturl ?? '';
                      }, 2000);
                    }
                    else {
                      setTimeout(() => {
                        window.location.href = dataAttrAPI?.dataset?.redirectUrl ?? '';
                      }, 2000);
                    }
                  } else {
                    this.showMessage('error');
                  }
                })
                .catch((error) => {
                  this.showMessage('error');
                });
            } else {
            }
          })
          .catch((err) => {
            this.showMessage('fail');
          });
      } catch {
        this.showMessage('error');
      }
    });
  },
};

signUp.init();

export { signUp };
